export default "__VITE_ASSET__99Qb0qdT__";